(() => {
  if (window.fitkaCrosssellLoaded) return;
  window.fitkaCrosssellLoaded = true;

  const variantsFor = (widget) => {
    try {
      return JSON.parse(widget.querySelector('[data-fitka-crosssell-variants]')?.textContent || '[]');
    } catch {
      return [];
    }
  };

  const showVariantImage = (widget, variant) => {
    const image = widget.querySelector('.fitka-crosssell__image');
    if (!image || !variant?.image) return;
    if (image.getAttribute('src') === variant.image) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.setAttribute('src', variant.image);
  };

  const updateColor = (widget, newColor) => {
    const size = widget.querySelector('[data-fitka-crosssell-variant]');
    const color = widget.querySelector('[data-fitka-crosssell-color]');
    if (!size || !color) return;
    const previousSize = size.selectedOptions[0]?.textContent?.trim();
    const options = variantsFor(widget).filter(v => v.available && v.color === newColor);
    if (!options.length) return;

    const selected = options.find(v => v.size === previousSize) || options[0];
    const newOptions = options.map(v => {
      const opt = document.createElement('option');
      opt.value = String(v.id);
      opt.textContent = v.size;
      opt.selected = String(v.id) === String(selected.id);
      return opt;
    });
    size.replaceChildren(...newOptions);
    color.value = newColor;
    showVariantImage(widget, selected);
  };

  document.addEventListener('change', event => {
    const target = event.target;
    if (!target.matches('[data-fitka-crosssell-variant], [data-fitka-crosssell-color]')) return;
    event.stopPropagation();
    const widget = target.closest('[data-fitka-crosssell]');
    if (!widget) return;

    if (target.matches('[data-fitka-crosssell-color]')) {
      updateColor(widget, target.value);
    } else {
      const variant = variantsFor(widget).find(v => String(v.id) === target.value && v.available);
      showVariantImage(widget, variant);
    }
  }, true);

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-fitka-crosssell-add]');
    if (!button || button.disabled) return;
    const widget = button.closest('[data-fitka-crosssell]');
    const select = widget?.querySelector('[data-fitka-crosssell-variant]');
    const status = widget?.querySelector('[data-fitka-crosssell-status]');
    if (!select?.value) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) {
      status.hidden = true;
      status.textContent = '';
    }

    try {
      const data = new FormData();
      data.append('id', select.value);
      data.append('quantity', '1');
      data.append('sections', 'cart-drawer,cart-icon-bubble');
      data.append('sections_url', window.location.pathname);

      const endpoint = window.routes?.cart_add_url || '/cart/add.js';
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || status?.dataset.defaultError || 'Nepodařilo se přidat produkt.');
      }
      const drawer = document.querySelector('cart-drawer');
      if (widget.dataset.location === 'drawer' && drawer && result.sections?.['cart-drawer']) {
        drawer.renderContents(result);
      } else {
        window.location.assign(window.routes?.cart_url || '/cart');
      }
    } catch (error) {
      if (status) {
        status.textContent = error.message || status.dataset.defaultError;
        status.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();